import React, {useContext, useEffect, useState} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import axiosInstance from "../../axiosInstance";
import axios from "axios";
import {LanguageContext} from "/src/LanguageContext";
import {SettingsContext} from "/src/SettingsContext";
import {VisitedContext} from "/src/VisitedContext";
import TextBlock from "/src/components/page/TextBlock";
import VideoBlock from "/src/components/page/VideoBlock";
import AudioBlock from "/src/components/page/AudioBlock";
import AudiosyncBlock from "/src/components/page/AudiosyncBlock";
import ConnectboxBlock from "/src/components/page/ConnectboxBlock";
import PhotoBlock from "/src/components/page/PhotoBlock";
import QuestionBlock from "/src/components/page/QuestionBlock";
import LinkBlock from "/src/components/page/LinkBlock";
import VariableBlock from "/src/components/page/VariableBlock";
import ActionButtonBlock from "/src/components/page/ActionButtonBlock";
import {useTranslation} from 'react-i18next';
import i18n from "../../i18n";
import {showMultiLingualText} from "@/utils/LanguageUtils";
import {ChevronLeftIcon} from "@heroicons/react/24/solid";
import {ChevronRightIcon} from "@heroicons/react/24/outline";
import {ToursContext} from "@/ToursContext";
import {useOverlay} from "@/OverlayContext";
//import useSWR from 'swr';

export default function TourPoint(props) {

    const params = useParams();
    let { point, page } = params;
    console.log(point, page, props.tourPoint);

    const tourPoint = props.tourPoint;

    const navigate = useNavigate();

    const language = useContext(LanguageContext);
    const { tourSettings } = useContext(SettingsContext);
    const visited = useContext(VisitedContext);
    const location = useLocation();
    const { t } = useTranslation();

    const { activeTour } = useContext(ToursContext);

    const visitedPoints = visited.points;

    const selectedLanguage = language.state.selected;

    const [pointData, setPointData] = useState([])
    const [activePage, setActivePage] = useState("")
    const [pageContent, setPageContent] = useState("")
    const [hasQuiz, sethasQuiz] = useState(false)

    const [form, setForm] = useState( {
        code: '',
        hasQuiz: false,
        quiz_answers: {},
        variables: visited.variables
    });
    const { setOverlayTitle, setOverlaySubtitle, setOverlayImage } = useOverlay();

    // const fetchMediaUrls = async () => {
    //     console.log("fetch urls via fetchMediaUrls()");
    //     const mediaUrls = [
    //         { url: 'http://localhost:8081/api/v2/client/media?tour=42&id=15', cacheKey: 'media_15' },
    //         { url: 'http://localhost:8081/api/v2/client/media?tour=42&id=20', cacheKey: 'media_20' },
    //         { url: 'http://localhost:8081/api/v2/client/media?tour=42&id=37 ', cacheKey: 'media_37' },
    //         // Add more media URLs and cache keys as needed
    //     ];
    //     console.log(mediaUrls);
    //     let error = null;
    //     return {mediaUrls, error};
    // }
    //
    // const { mediaUrls, error } = useSWR(fetchMediaUrls);
    //
    //
    // useEffect(() => {
    //     console.log("mediaUrls is changed", mediaUrls);
    //     if (mediaUrls) {
    //         // Fetch and cache media files when mediaURLs are available
    //         const urls = mediaUrls.map((item) => item.url);
    //         console.log("fetchMedia:", urls);
    //         fetchMedia(urls);
    //     }
    // }, [mediaUrls]);

    // load content of a page
    useEffect(() => {
        if (typeof activePage !== "undefined" && activePage) {
            loadContent()
        }
    }, [activePage, i18n.language]);

    // set activePage when page in the url changes
    useEffect(() => {
        console.log('Current page:', page);
        if (typeof page !== "undefined") {
            setActivePage(page);
        }
    }, [page]);

    // get a list of all pages for this tourPoint
    useEffect(() => {
        loadData()
    }, [tourPoint]);

    // Helper function to find the closest scrollable parent
    const findScrollableParent = (element) => {
        if (!element) return document.documentElement;
        
        // Check if the element is scrollable
        const isScrollable = element.scrollHeight > element.clientHeight;
        
        if (isScrollable) {
            return element;
        }
        
        // If not scrollable, check the parent
        return findScrollableParent(element.parentElement);
    };

    // async function fetchMedia(urls) {
    //     const responses = await Promise.all(
    //         urls.map(async (url) => {
    //             const response = await fetch(url);
    //             const blob = await response.blob();
    //             return blob;
    //         })
    //     );
    //
    //     // Return an array of blobs
    //     return responses;
    // }


    /**
     * @returns {Promise<void>}
     */
    const loadContent = async () => {
        console.log('Load content of page:', activePage);

        setPageContent("");
        let requestParams = {
            ...({
                "lang": i18n.language
            }),
            //    "point_id": point,
            //     "page_id": activePage
        }

        // get point
        let headers = {
            ...(activeTour && {
                "X-Tour-Id": activeTour
            }),
        }
        axiosInstance.get(process.env.CLIENT_API_URL+"/client/content/"+activePage,{ params: requestParams, headers: headers}) // get points
            .then((response) => {
                let content = response.data;

                setPageContent(content);

                if (pointData.image && tourSettings?.points_display_image) {
                    setOverlayImage(pointData.image)
                }

                setOverlayTitle(showMultiLingualText(pointData.title, '', true))
                setOverlaySubtitle(showMultiLingualText(content.title, ''))

                // Find the closest scrollable parent
                const scrollableParent = findScrollableParent(document.getElementById('overlay-root').firstChild);
                
                if (scrollableParent) {
                    scrollableParent.scrollTo({ 
                        top: 0
                    });
                }

                if (props.onContentLoaded) {
                    props.onContentLoaded();
                }

                //   // get media from content
                // let mediaUrls = [];
                // content.elements.forEach((element) => {
                //     element.fields.forEach((field) => {
                //         if (typeof field.value !== "undefined") {
                //             console.log("buffer field:", field.value, field);
                //             mediaUrls.push({url: field.value, cacheKey: "media_"+field.content_value});
                //         }
                //     })
                // })
                //
                // console.log(mediaUrls);

                // Track page view
                var _paq = window._paq = window._paq || [];
                _paq.push(['setCustomUrl', location.pathname]);
                _paq.push(['setDocumentTitle', showMultiLingualText(pointData.title, pointData.name) + " - " + showMultiLingualText(content.title, content.name)]);
                _paq.push(['trackPageView']);


                console.log("track page content", content);
            })
    }

    const handleSubmit = event => {
        console.log("handleSubmit Point.js");
        console.log(event);
        event.preventDefault();

        loadData(form.code)
    }

    /**
     * @param event
     */
    const handleChange = event => {

        console.log("handleChange Point.js");
        console.log(event);

        let formData = {...form};

        if (event.target.name === 'code') {
            formData.code = event.target.value;
        }
        if (event.target.name.includes("answer_")) {
            let questionId = event.target.name.replace("answer_", "");
            formData.quiz_answers[questionId] = event.target.value;
        }

        console.log(event.target.name, event.target.value);
        console.log("form:", formData);

        setForm(formData);

    }

    // Function to handle changes in form inputs
    const handleChangeElement = (event) => {
        const { name, value } = event.target;

        console.log(event.target.name, event.target.value);

        // store fields temporary
        setForm(prevState => ({
            ...prevState,
            variables: {
                ...prevState.variables,
                [name]: value
            }
        }));
    };


    const handleSubmitElements = (event, nextPage, to = null) => {
        event.preventDefault();
        console.log("handleSubmitElements TourPoint.js");
        console.log(event, form.variables, form.quiz_answers);

        // Update context with merged fields
        visited.setVariables({
            ...visited.variables,
            ...form.variables
        });

        if (Object.keys(form.quiz_answers).length > 0 ) {

            let score_start = 0;
            let score_complete = 0;
            if (Object.keys(pointData.settings).includes("quiz")) {
                score_start = parseInt(pointData.settings.quiz.percentage_start) || 0;
                score_complete = parseInt(pointData.settings.quiz.percentage_complete) || 0;
            }

            let point_score = score_start;

            let answers = { ...visited.points[pointData.data.id]['quiz_answers'], ...form.quiz_answers };  // merge form answers

            console.log("active point", pointData);

            let questionsCount = pointData.quiz_questions?.length || 0;
            let answerCount =  Object.keys(answers).length || 0;

            console.log("questionsCount",questionsCount);
            console.log("answerCount",answerCount);

            let point_progress = Math.round(((answerCount/questionsCount) * 100)*100) / 100;

            if (questionsCount > 0 && answerCount > 0) {
                for (const [answered_question_id, selected_option_id] of Object.entries(answers)) {

                    console.log("progress percentage " + point_progress);

                    if (point_progress === 100) {
                        // send new answers to backend if all questions are filled in
                        const formData = new FormData();
                        formData.append("answer", selected_option_id)
                        formData.append("language", i18n.language)

                        axios.post(process.env.CLIENT_API_URL + `/client/quiz/question/${answered_question_id}/answer`, formData)
                            .then((response) => {
                                console.log(response.data)
                            })
                    }

                    const matchedQuestion = pointData.quiz_questions.find(question => parseInt(question.id) === parseInt(answered_question_id));
                    const answer_score = matchedQuestion?.options.find(option => parseInt(option.id) === parseInt(selected_option_id))?.advanced?.score ?? 0;
                    point_score += answer_score;
                }
            }


            let data = {
                ...(point_score && {
                    "quiz_score": point_score
                }),
                ...(point_score && {
                    "quiz_success": (point_score >= score_complete)
                }),
                ...(point_progress && {
                    "quiz_point_progress": point_progress
                }),
                ...(answers && {
                    "quiz_answers":  answers
                })
            }
            setVisited(pointData.data.id, data);

            console.log(score_start, score_complete, point_score);

        }

        if (nextPage && !to) {
            console.log("switch to ", nextPage);
            setActivePage(nextPage);
        }

        if (to) {
            console.log("navigate to ", to);
            navigate(to);
        }

    }


    const setVisited = (pointId, data) => {

        let visitedPoints = {...visited.points};

        if (typeof visitedPoints[pointId] === "undefined" ) {

            // set new visited point data
            visitedPoints[pointId] = {...data}

        } else {
            // add data to existing visited point data
            visitedPoints[pointId] = { ...visitedPoints[pointId], ...data }
        }
        visited.setVisitedPoints(visitedPoints);
    }
    //
    // const saveAnswers = (pointId, answers) => {
    //     console.log("saveAnswers", pointId, answers);
    //
    //     let visitedAnswers = {...visited.quiz_answers};
    //
    //
    //     if (typeof visitedAnswers[pointId] === "undefined" ) {
    //
    //         // set new visited answers
    //         visitedAnswers[pointId] = { ...answers }
    //
    //     } else {
    //         // add data to existing visited answers
    //         visitedAnswers[pointId] = { ...visitedAnswers[pointId], ...answers }
    //     }
    //     visited.setQuizAnswers(visitedAnswers);
    //
    //
    // }


    const loadData = async (code=null) => {

        console.log("load details for tourPoint ", tourPoint);

        // if no code is provided, check the visited data to load the code there if exists
        if (!code && Object.keys(visitedPoints).includes(tourPoint.id)) {
            code = visitedPoints[tourPoint.id]?.code;
        }

        // if (Object.keys(pointData).length > 0) {
        //     // TODO hierdoor werkt de code niet meer!
        //     console.log("tourPoint already loaded", pointData);
        //     return;
        // }


        console.log("use code " + code);

        let requestParams = {
            ...({
                "lang": i18n.language
            }),
            //      "point_id": tourPoint.point.id,

        }

        let headers = {

            ...(code && {
                "Authorization": `code ${code}`
            }),
            ...(activeTour && {
                "X-Tour-Id": activeTour
            }),
        }

        // get tour-point
        axiosInstance.get(process.env.CLIENT_API_URL+"/client/tour-points/"+tourPoint.id,{ params: requestParams, headers: headers}) // get points
            .then((response) => {



                setPointData(response.data);

                console.log("tourPoint details:");
                console.log(response.data)

                // enable quiz module logic
                if (response.data.quiz_questions?.length > 0 && !hasQuiz) {
                    sethasQuiz(true);
                }

                // mark tourPoint as visited
                if (response.data.code_required === false) {

                    // set initial score when visiting the point for the first time
                    let score_start = 0;
                    if (typeof visited.points[response.data.point.id]?.quiz_score === "undefined") {
                        if (Object.keys(response.data.settings).includes("quiz")) {
                            score_start = parseInt(response.data.settings.quiz.percentage_start) || 0;
                        }
                    }

                    let data = {
                        ...(code && {
                            "code": code
                        }),
                        ...(score_start && {
                            "quiz_score": score_start
                        }),
                    }

                    setVisited(response.data.point.id, data);

                    // set the first page as active
                    if (typeof page === "undefined" && response.data.pages.length > 0) {
                        setActivePage(response.data.pages[0].id);
                        console.log("set page: ",response.data.pages[0], page);
                    }


                } else {
                    if (!code) {
                        // Track page view
                        var _paq = window._paq = window._paq || [];
                        _paq.push(['setCustomUrl', location.pathname]);
                        _paq.push(['setDocumentTitle', showMultiLingualText(response.data.title, response.data.point.name) + " - " + "code required"]);
                        _paq.push(['trackPageView']);
                    }
                }



          })

    }

    /**
     * @returns {boolean}
     */
    const isComplete = () => {
        let complete = false;

        if (!pointData || !pointData.point) {
            return complete;
        }

        if (Object.keys(visited.points).length > 0 && Object.keys(visited.points).some(function(k){ return ~k.indexOf(pointData.point.id) })) {

            // TODO check if the quiz module is enabled
            complete = (Object.keys(visited.points[pointData.point.id]).includes("quiz_point_progress") && parseInt(visited.points[pointData.point.id]["quiz_point_progress"]) === 100)
        }

        return complete;
    }

    const getQuizAnswer = (item) => {
        let answer = null;

        if (!pointData || !pointData.point) {
            return answer;
        }

        if (Object.keys(visited.points).length > 0 && Object.keys(visited.points).some(function (k) {
            return ~k.indexOf(pointData.point.id)
        })) {

            if (item.type === "quiz_question" && Object.keys(visited.points[pointData.point.id]).includes("quiz_answers")) {
                let pointAnswers = visited.points[pointData.point.id]["quiz_answers"];

                return pointAnswers[item.data.point.id];
            }
        }

        return answer;
    }

    const getQuizScore = () => {

        let score_complete = 0;
        if (Object.keys(pointData).length > 0 && Object.keys(pointData.settings).includes("quiz")) {
            score_complete = parseInt(pointData.settings.quiz.percentage_complete) || 0;
        }

        if (score_complete === 0) {
            return null;
        }

        let score = (Math.ceil(visitedPoints[pointData.point.id]?.quiz_score || 0));
        let result = "Score: " + score;

        if (window.location.hostname === "denhaag-ctrl.tourio.com" || window.location.hostname === "denhaag-ctrl.dev.tourio.com") {
            score = (Math.ceil((visitedPoints[pointData.point.id]?.quiz_score || 0) / 10) * 10);
            result = <img className="w-36 m-auto" src={'/static/thewalk/quiz/progress_'+score+'.png'}/>;
        }

        return result;
    }

    const isLastPage = (pageId) => {
        return parseInt(pageId) === parseInt(pointData.pages.at(-1)?.id)
    }

    const isFirstPage = (pageId) => {
        return parseInt(pageId) === parseInt(pointData.pages.at(0)?.id)
    }

    const getPageNumber = (pageId) => {
        if (typeof pointData === "undefined") { return null }
        let index = pointData?.pages.findIndex(x => parseInt(x.id) === parseInt(pageId));
        return index+1;
    }

    const nextPage = (pageId) => {
        if (typeof pointData === "undefined") { return null }
        let index = pointData?.pages.findIndex(x => parseInt(x.id) === parseInt(pageId));

        return pointData.pages[index+1];
    }

    const previousPage = (pageId) => {
        if (typeof pointData === "undefined") { return null }
        let index = pointData?.pages.findIndex(x => parseInt(x.id) === parseInt(pageId));
        return pointData.pages[index-1];
    }




    return (

        <div>

                    {( getQuizScore()) &&
                        <div className="justify-between items-center p-4 text-center text-gray-800">
                            {getQuizScore()}
                        </div>
                    }


                    <div className="p-4 flow-root space-y-4 w-full">
                        <div>
                            {pointData.code_required ? (

                                <div>
                                    <form onSubmit={ handleSubmit } className="space-y-5">
                                        <div className="mt-3 sm:mt-5">
                                            <h3 className="text-base font-semibold leading-6 text-gray-900">
                                                Vul hier de code in
                                            </h3>
                                            <div className="mt-2">
                                                <p className="text-gray-600 mb-2">
                                                    Vul de code in om toegang te krijgen tot de red zone. Ergens om je heen is deze code terug te vinden. Los hem op en open het dossier.
                                                </p>
                                            </div>
                                        </div>

                                        <div>
                                            <input id="code" name="code" type="text" autoComplete="false" placeholder="Code" onChange={handleChange}
                                                   className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-0 focus:border-main"/>
                                        </div>

                                        <div>
                                            <button
                                                type="submit"
                                                className="inline-flex w-full justify-center rounded-md 0 px-3 py-2 font-semibold shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
                                                style={{"backgroundColor": `${ tourSettings.theme_color}`, "color": `${ tourSettings.theme_text_color}`}}
                                            >
                                                GO
                                            </button>
                                        </div>

                                    </form>
                                </div>
                            ) : (
                                <div>

                                    {pointData && pageContent && pageContent?.blocks &&
                                        <div className="space-y-4">
                                            {pageContent?.blocks.map((item) => (
                                                <div key={item.id}>
                                                    {
                                                        {
                                                            'video': <VideoBlock item={item}/>,
                                                            'audio': <AudioBlock item={item}/>,
                                                            'audiosync': <AudiosyncBlock item={item}
                                                                                         state={form}/>,
                                                            'text': <TextBlock item={item}/>,
                                                            'photo': <PhotoBlock item={item}/>,
                                                            'quiz_question': <QuestionBlock item={item}
                                                                                            answer={getQuizAnswer(item)}
                                                                                            complete={isComplete()}
                                                                                            onChange={handleChange}/>,
                                                            'link': <LinkBlock item={item}/>,
                                                            'connectbox': <ConnectboxBlock item={item}/>,
                                                            'variable': <VariableBlock item={item} state={form}
                                                                                       updateState={handleChangeElement}/>,
                                                            // 'action_button': <ActionButtonBlock item={item}
                                                            //                                     onAction={handleActionSubmit}/>
                                                        }[item.type]
                                                    }
                                                </div>
                                            ))}
                                        </div>
                                    }
                                </div>
                            )}

                        </div>

                    </div>


                    {pointData?.pages?.length > 0 &&
                        <div className="container mx-auto mb-20">

                            {pointData?.pages?.length > 1 &&
                                <div className="my-5 w-full">
                                    <div className={` max-w-max mx-auto`}>
                                        <div className={`flex`}>
                                            <button onClick={(event) => handleSubmitElements(event,previousPage(activePage)?.id)}
                                                    className="rounded-l-full py-2 px-2 leading-6 text-bold disabled:opacity-50" disabled={isFirstPage(activePage)}  style={{ "backgroundColor": `${tourSettings.contrast_color}`, "color": `${tourSettings.contrast_text_color}` }}>
                                                <ChevronLeftIcon className={`w-5 h-5`}/>
                                            </button>

                                            <div
                                                className="inline-grid mx-[2px] h-10 px-4 text-center place-items-center" style={{ "backgroundColor": `${tourSettings.contrast_color}`, "color": `${tourSettings.contrast_text_color}` }}>
                                                <div>{getPageNumber(activePage)} / { pointData?.pages?.length }</div>
                                            </div>


                                            <button onClick={(event) => handleSubmitElements(event,nextPage(activePage)?.id)}
                                                    className="rounded-r-full py-1 px-2 leading-6 disabled:opacity-50" disabled={isLastPage(activePage)} style={{ "backgroundColor": `${tourSettings.contrast_color}`, "color": `${tourSettings.contrast_text_color}` }}>
                                                <ChevronRightIcon className={`w-5 h-5`}/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            }

                            {isLastPage(activePage) && hasQuiz && visited.points[pointData.point.id].quiz_point_progress !== 100 &&
                                <div className={`flex items-center mt-14`}>
                                    <button
                                        onClick={(event) => handleSubmitElements(event, null, `/${params.language ? `${params.language}/` : ''}points`)}
                                        style={{"lineHeight": "normal", "backgroundColor": `black`, "color": `white`}}
                                        className="py-1 px-2 rounded-lg mx-auto">
                                        {t((hasQuiz && visited.points[pointData.point.id].quiz_point_progress !== 100) ? 'button.send' : 'button.back_to_overview')}
                                    </button>
                                </div>
                            }

                        </div>
                    }


                </div>
    );

}
